/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import { labourTotals, type HoursWeek } from "./types";

type Props = { week: HoursWeek };

const pct = (v: number | null) => (v == null ? "—" : `${v.toFixed(1)}%`);

// The week at a glance: hours, and for managers labour and prime cost vs sales.
export const HoursSummary = defineComponent<Props>({
  name: "HoursSummary",
  props: ["week"],
  setup(props) {
    const { t } = useLocalization();
    return () => {
      const s = labourTotals(props.week);
      const tiles: { label: string; value: string; hint?: string }[] = [
        { label: t("workday.hours.planned_hours"), value: s.planned.toFixed(1) },
        { label: t("workday.hours.worked_hours"), value: s.worked.toFixed(1) },
      ];
      if (props.week.can_see_wages) {
        tiles.push(
          {
            label: t("workday.hours.labour_cost"),
            value: s.cost.toFixed(2),
            hint: s.missingRate ? t("workday.hours.missing_rate").replace("{count}", String(s.missingRate)) : undefined,
          },
          { label: t("workday.hours.net_sales"), value: props.week.net_sales.toFixed(2) },
          { label: t("workday.hours.labour_pct"), value: pct(s.labourPct) },
          { label: t("workday.hours.prime_pct"), value: pct(s.primePct), hint: t("workday.hours.prime_hint").replace("{food}", props.week.food_cost.toFixed(2)) },
        );
      }
      return (
        <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {tiles.map((x) => (
            <div key={x.label} class="rounded-2xl border border-base-300 bg-base-100 p-4">
              <div class="text-xs text-base-content/60">{x.label}</div>
              <div class="mt-1 text-2xl font-bold tabular-nums">{x.value}</div>
              {x.hint && <div class="mt-1 text-xs text-base-content/50">{x.hint}</div>}
            </div>
          ))}
        </div>
      );
    };
  },
});
